
import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideBarContainer.scss';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../utils/utils';

class SideBarContainer extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    styl: PropTypes.string,
    children: PropTypes.array.isRequired,
  };

  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      backgroundColor: null,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  render() {
    return (
      <div style={{ ...this.state.style, width: `${this.props.width}%`, position: 'relative', marginTop: '20px', marginLeft: '10px' }} className={this.props.styl || 'side-bar-container'}>
        {this.props.children}
      </div>
    );
  }
}

export default withStyles(s)(SideBarContainer);



// WEBPACK FOOTER //
// src/components/SideBarMenu/SideBarContainer/SideBarContainer.js